import styled, { css } from 'styled-components';
import { Icon } from '@elfsight/lib-icon';
import { createReadableClass } from '@elfsight/widget-utils';
import { useLingui } from '@lingui/react/macro';
import { useSettings } from '@wu/widget-core';
import { useWidgetDimensions } from '../widget-dimensions-provider';
import EmptyServicesIcon from './no-service-icon.svg?react';
import UnavailableTimeslotIcon from './time-slot-unavailable.svg?react';
import { Title2 } from './typography';

type EmptyMessageProps = {
  type: 'services' | 'time-slots';
};

const icons = {
  services: EmptyServicesIcon,
  'time-slots': UnavailableTimeslotIcon
};

export function EmptyMessage({ type }: EmptyMessageProps) {
  const { textColor } = useSettings();
  const { t } = useLingui();
  const { isMobile } = useWidgetDimensions();

  const title1 =
    type === 'services'
      ? t`No services added.`
      : t`No available time slots in the upcoming days.`;
  const title2 =
    type === 'services'
      ? t`Please add a service to continue.`
      : t`Please check back later.`;

  return (
    <Container _isMobile={isMobile}>
      <Icon fill={textColor} size={48} component={icons[type]} />
      <TextContainer>
        <InfoText _isMobile={isMobile}>{title1}</InfoText>
        <InfoText _isMobile={isMobile}>{title2}</InfoText>
      </TextContainer>
    </Container>
  );
}

const InfoText = styled(Title2).attrs({
  className: createReadableClass({
    component: 'empty-message',
    element: 'info-text'
  })
})<{ _isMobile: boolean }>`
  max-width: 350px;
  ${({ _isMobile }) =>
    _isMobile &&
    css`
      font-size: 15px;
    `}
`;

const Container = styled.div.attrs({
  className: createReadableClass({
    component: 'empty-message',
    element: 'container'
  })
})<{ _isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 40px;
  gap: ${({ _isMobile }) => (_isMobile ? '16px' : '20px')};
  align-items: center;
`;

const TextContainer = styled.div.attrs({
  className: createReadableClass({
    component: 'empty-message',
    element: 'text-container'
  })
})``;
